import React from 'react';

import {
  Accordion,
  AccordionDetails,
  AccordionProps,
  AccordionSummary,
  AccordionSummaryProps,
  Divider,
  ListItem,
  MenuItem,
  MenuItemProps,
  styled,
} from '@mui/material';

import { SHADCN_COLORS } from '@itp/talent/theme';

import { BodyText, BodyTextBold } from '../../../core/typography';

export const DDMenuItemTitle = styled(BodyTextBold)(({ theme }) => ({
  color: theme.palette.primary.main,
  display: 'block',
  height: theme.spacing(6),
  padding: theme.spacing(2, 2, 1),
  textTransform: 'capitalize',
}));

export const DDMenuItem = styled(MenuItem)<MenuItemProps & { href?: string }>(({ theme }) => ({
  '&:hover': {
    backgroundColor: SHADCN_COLORS.rowHover,
  },
  '&.Mui-selected': {
    backgroundColor: 'inherit',
    color: theme.palette.primary.main,
  },
  '&.MuiMenuItem-divider': {
    paddingBottom: theme.spacing(2),
  },
  alignItems: 'start',
  flexDirection: 'row',
  gap: theme.spacing(2),
  minHeight: '36px',
}));

export const StyledDivider = styled(Divider)(() => ({
  '&&&': {
    margin: 0,
  },
}));

export const SwitchCompanyAccordion = styled((props: AccordionProps) => (
  <Accordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  '&::before': {
    display: 'none',
  },
  listStyleType: 'none',
  padding: 0,
}));

export const SwitchCompanyAccordionSummary = styled((props: AccordionSummaryProps) => (
  <AccordionSummary {...props} />
))(({ theme }) => ({
  '& .MuiAccordionSummary-content': {
    '&.Mui-expanded': {
      color: theme.palette.primary.main,
      fontWeight: '500',
    },
    color: 'rgb(88,88,88)',
    display: 'flex',
    gap: theme.spacing(2),
    margin: 0,
  },
  '&:hover': {
    backgroundColor: SHADCN_COLORS.rowHover,
  },
  minHeight: '36px',
}));

export const SwitchCompanyAccordionDetails = styled(AccordionDetails)(({ theme }) => ({
  backgroundColor: theme.palette.grey[100],
  padding: 0,
}));

export const SelectedCompanyListItem = styled(ListItem)(({ theme }) => ({
  backgroundColor: SHADCN_COLORS.rowHover,
  color: 'rgb(88,88,88)',
  gap: theme.spacing(1),

  [theme.breakpoints.down('sm')]: {
    display: 'grid',
    gap: 0,
  },
}));

export const SelectedCompanyListItemTitle = styled(BodyText)(({ theme }) => ({
  fontSize: '11px',
  letterSpacing: '0.17px',
  textTransform: 'uppercase',
}));
